module.exports = __webpack_public_path__ + "media/images/ios-code-0f71ad0744fc351ba76ce34f2090151e.png";